import { render, staticRenderFns } from "./FileTemplates.vue?vue&type=template&id=a9b104f0&"
import script from "./FileTemplates.vue?vue&type=script&lang=js&"
export * from "./FileTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QTable,QInput,QIcon,QTd} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QTable,QInput,QIcon,QTd})
